'use client'

import { getCalApi } from "@calcom/embed-react"
import { useEffect } from "react"
import { trackEvent } from "@/lib/utils"

export function CalProvider() {
  useEffect(() => {
    (async function () {
      // Initialize 15min namespace
      const cal15min = await getCalApi({"namespace":"15min"})
      cal15min("ui", {"hideEventTypeDetails":false,"layout":"month_view"})
      
      // Track when booking is successful
      cal15min("on", {
        action: "bookingSuccessful",
        callback: (e: any) => {
          trackEvent('booking_successful', {
            event_category: 'conversion',
            event_label: '15min_consultation',
            value: 1,
          })
        }
      })
      
      // Initialize work-with-me namespace
      const calWorkWithMe = await getCalApi({"namespace":"work-with-me"})
      calWorkWithMe("ui", {"hideEventTypeDetails":false,"layout":"month_view"})
      
      // Track when work-with-me booking is successful
      calWorkWithMe("on", {
        action: "bookingSuccessful",
        callback: (e: any) => {
          trackEvent('booking_successful', {
            event_category: 'conversion',
            event_label: 'work_with_me',
            value: 1,
          })
        }
      })
    })()
  }, [])

  return null
}
